import React, { useEffect } from "react";
import dayjs from 'dayjs'
import { Helmet } from "react-helmet-async";
import { Badge, Button, Card, Col, Container, Row, Table } from "react-bootstrap";
import { Company } from "../../types/company";
import { useGetCompanyByIdQuery } from "../../redux/slices/companiesSlice";
import useAppSelector from "../../hooks/useAppSelector";
import { Link, useNavigate, useParams } from "react-router-dom";
import LoadingAlert from "../LoadingAlert";
import ErrorAlert from "../ErrorAlert";
import { ArrowLeftCircle, SkipBack } from "react-feather";
import { Edit } from "react-feather";

const CompanyDetails = ({ admin }: { admin: boolean }) => {

    const { companyId } = useParams();

    const { data: company, isLoading: isLoadingCompany, isError: isErrorCompany, isSuccess: isSuccessCompany, error: errorCompany } = useGetCompanyByIdQuery(companyId ? companyId : '')

    const navigate = useNavigate();


    let content;

    if (isLoadingCompany) {
        content = (
            <LoadingAlert title="Loading..." />
        )
    } else if (isErrorCompany) {
        content = (
            <ErrorAlert title="Error" error={JSON.stringify(errorCompany)} />
        )
    } else if (isSuccessCompany) {
        console.log('company loaded', company);
        content = (
            <Card>
                <Card.Header>
                    <Row className="mb-2 mb-xl-3">
                        <Col xs="auto" className="d-none d-sm-block">
                            {admin ? (
                                <Card.Title className="mb-0">Admin - Company Details</Card.Title>
                            ) : (
                                <Card.Title className="mb-0">Company Details</Card.Title>
                            )}
                        </Col>
                        <Col xs="auto" className="ms-auto text-end mt-n1">
                            {admin ? (
                                <Row>
                                    <Col>
                                        <Button variant="secondary" className="shadow-sm" onClick={() => navigate(`/admin/companies/company/${companyId}/edit`)}>
                                            <Edit />
                                        </Button>
                                    </Col>
                                    <Col>
                                        <Button variant="primary" className="shadow-sm" onClick={() => navigate('/admin/companies')}>
                                            <ArrowLeftCircle />
                                        </Button>
                                    </Col>
                                </Row>

                            ) : (
                                <Button variant="primary" className="shadow-sm" onClick={() => navigate('/companies')}>
                                    <ArrowLeftCircle />
                                </Button>
                            )}
                        </Col>
                    </Row>
                </Card.Header>
                <Card.Body>
                    <Table size="sm" className="my-2">
                        {company ? (
                            <tbody>
                                <tr>
                                    <th>Name</th>
                                    <td><h4>{company?.tradingAs}</h4></td>
                                </tr>
                                <tr>
                                    <th>Website</th>
                                    <td><a href={`https://${company.website}`} target="_blank">{company.website}</a></td>
                                </tr>
                                <tr>
                                    <th>Post Code</th>
                                    <td>{company.postcode}</td>
                                </tr>
                                <tr>
                                    <th>MEF Member?</th>
                                    <td>{company.mefMember !== true ?
                                        (
                                            <Badge bg="danger">No</Badge>
                                        ) : (
                                            <Badge bg="success">Yes</Badge>
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <th>Verified?</th>
                                    <td>{company.verified !== true ?
                                        (
                                            <Badge bg="danger">No</Badge>
                                        ) : (
                                            <Badge bg="success">Yes</Badge>
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <th>Categories</th>
                                    <td>{company.category.map(anz => (
                                        <>
                                            {/* @ts-ignore */}
                                            <li>{anz.name}</li>
                                        </>
                                    ))}
                                    </td>
                                </tr>
                            </tbody>
                        ) : ''}
                    </Table>
                    <br />
                    <Row>
                        <Col md={6}>
                            <Card>
                                <Card.Header>
                                    <Card.Title>Capabilities</Card.Title>
                                </Card.Header>
                                <Card.Body>
                                    <Table responsive>
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Mobile?</th>
                                                <th>Verified?</th>
                                                <th>Sites</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {company && company.capabilities.map(capability => (
                                                <tr>
                                                    {/* @ts-ignore */}
                                                    <td>{capability?.capabilityId?.name}</td>
                                                    {/* @ts-ignore */}
                                                    <td>{capability?.mobile !== true ?
                                                        (
                                                            <Badge bg="danger">No</Badge>
                                                        ) : (
                                                            <Badge bg="success">Yes</Badge>
                                                        )}
                                                    </td>
                                                    {/* @ts-ignore */}
                                                    <td>{capability?.verified !== true ?
                                                        (
                                                            <Badge bg="danger">No</Badge>
                                                        ) : (
                                                            <Badge bg="success">Yes</Badge>
                                                        )}
                                                    </td>
                                                    <td>
                                                        {/* @ts-ignore */}
                                                        {capability?.sites?.map(site => (
                                                            <li>{site}</li>
                                                        ))}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={3}>
                            <Card>
                                <Card.Header>
                                    <Card.Title>Industries</Card.Title>
                                </Card.Header>
                                <Card.Body>
                                    <Table responsive>
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Verified?</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {company && company.industries.map(industry => (
                                                <tr>
                                                    {/* @ts-ignore */}
                                                    <td>{industry?.industryId?.name}</td>
                                                    {/* @ts-ignore */}
                                                    <td>{industry?.verified !== true ?
                                                        (
                                                            <Badge bg="danger">No</Badge>
                                                        ) : (
                                                            <Badge bg="success">Yes</Badge>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={3}>
                            <Card>
                                <Card.Header>
                                    <Card.Title>Sub-Industries</Card.Title>
                                </Card.Header>
                                <Card.Body>
                                    <Table responsive>
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Verified?</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {company && company.subIndustries.map(industry => (
                                                <tr>
                                                    {/* @ts-ignore */}
                                                    <td>{industry?.industryId?.name}</td>
                                                    {/* @ts-ignore */}
                                                    <td>{industry?.verified !== true ?
                                                        (
                                                            <Badge bg="danger">No</Badge>
                                                        ) : (
                                                            <Badge bg="success">Yes</Badge>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Card.Body>
            </Card >
        )
    } else {
        content = (
            <LoadingAlert title="Loading.." />
        )
    }

    return content;
}

export default CompanyDetails